export default {
  name: "NotificationSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28.87 25.49A1 1 0 0 1 28 26h-7.1a5 5 0 0 1-9.8 0H4c-.76.02-1.27-.88-.86-1.52 1.56-2.59 2.26-5.66 2.93-8.63C7.24 10.72 8.46 5.44 14.5 4.7V3.5a1.5 1.5 0 1 1 3 0v1.2c5.92.75 7.17 6.03 8.37 11.15.7 2.97 1.42 6.04 2.98 8.63.19.31.2.7.02 1.01z",
  },
}
